// styles
import { AppContainer, Center } from "./styled";
import "react-loading-skeleton/dist/skeleton.css";

// api
import { sendErrorsLogs } from "../api/adminService";

// react
import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// redux
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../redux/Slice/authSlice";
import { authSelector } from "../redux/selectors/authSelector";

// pages
import MainPage from "../pages/MainPage";
import PodcastsPage from "../pages/PodcastsPage";
import PodcastDetailPage from "../pages/PodcastDetailPage";
import FavoritePage from "../pages/FavoritePage";

// themes & providers
import BaseSkeletonTheme from "../components/BaseSkeletonTheme";
import { HelmetProvider } from "react-helmet-async";

// components
import Header from "../components/Header/Header";
import Loader from "../components/Loader/Loader";
import FooterPlayer from "../components/FooterPlayer";
import { ErrorBoundary } from "../components/ErrorBoundary/ErrorBoundary";
import { CookieBanner } from "../components/CookieBanner";
import { CustomToaster } from "../components/CustomToaster";
import { PrivateRoute } from "./routes/PrivateRoute";
import { FeedbackButton } from "../components/FeedbackButton";
import { SeoHead } from "./SeoHead";
import { Footer } from "../components/Footer";
import { FooterPlayerProvider } from "../contexts/FooterPlayerContext";
import { usePlayerInit } from "./hooks/usePlayerInit";
import { usePlaybackProgress } from "./hooks/usePersistPlaybackProgress";

const PrivacyPage = lazy(() => import("../pages/PrivacyPage"));
const ContactsPage = lazy(() => import("../pages/ContactsPage"));

function App() {
  const dispatch = useDispatch();
  const { loadingApp } = useSelector(authSelector);

  usePlayerInit();
  usePlaybackProgress();

  useEffect(() => {
    dispatch(getUserData());
    sendErrorsLogs();
  }, [dispatch]);

  if (!loadingApp) {
    return (
      <Center>
        <Loader color="#fff" />
      </Center>
    );
  }

  return (
    <HelmetProvider>
      <SeoHead />
      <ErrorBoundary>
        <FooterPlayerProvider>
          <AppContainer>
            <CookieBanner />
            <FeedbackButton />
            <BaseSkeletonTheme>
              <CustomToaster />
              <Header />
              <Suspense
                fallback={
                  <Center>
                    <Loader color="#fff" />
                  </Center>
                }
              >
                <Routes>
                  <Route path="/" element={<MainPage />} />
                  <Route path="/podcasts" element={<PodcastsPage />} />
                  <Route
                    path="/podcasts/:podcastLink/:podcastItemId?"
                    element={<PodcastDetailPage />}
                  />

                  <Route element={<PrivateRoute />}>
                    <Route path="/favorite" element={<FavoritePage />} />
                  </Route>
                  <Route path="/policy-privacy" element={<PrivacyPage />} />
                  <Route path="/contacts" element={<ContactsPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
              <Footer />
              <FooterPlayer />
            </BaseSkeletonTheme>
          </AppContainer>
        </FooterPlayerProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
